<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">

                <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <button class="btn enrollment-list-buttons cursor-pointer" type="button"
                      *ngFor="let status of statusList"
                      [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                      (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 filter-list">
                      <ng-select [items]="emp_typeList" bindLabel="displayname" bindValue="_id"
                        placeholder="Select Type" [(ngModel)]="selected_employee_type"
                        [ngModelOptions]="{ standalone: true }" (change)="getTypeId($event)">
                      </ng-select>
                      <!-- <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                        <button type="button" class="btn btn-outline-primary btn2">{{employee_type}}</button>
                        <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                          aria-haspopup="true" aria-expanded="false">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" role="menu">
                          <button class="dropdown-item" *ngFor="let item of emp_typeList"
                            (click)="getTypeId(item?._id,item?.displayname)">{{item?.displayname}}</button>
                        </div>
                      </div> -->
                    </div>
                    <div class="col-flex-2 mb-1 position-relative" placement="top"
                      ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                        (keydown.enter)="getEmployeeSearch(searchVal)" />
                      <button class="btn search-btn glow position-absolute" (click)="getEmployeeSearch(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/employees/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>

                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)">
                    <ngx-datatable-footer>
                      <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                        <div class="datatable-footer-inner">
                          <div class="total-count">
                            <span>Total : {{page.totalPages}}
                              <span> &nbsp;<span *ngIf="activeTab !== 'exemployee'">Total Salary :
                                  {{total_salary}}</span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </ng-template>
                    </ngx-datatable-footer>

                  </ngx-datatable>
                </div>
                <div class="col">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Team Guideline</button>
                </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="employeetype" [width]="60">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <!-- <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">
                        {{ row?.user?.name | shortName }}
                      </div>
                    </div> -->

                    <!-- <div class="cell-line-height cursor-pointer" [routerLink]="['/employees/view', row?.user?._id]">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.user?.name }}
                        </p>
                      </div> -->
                    <div class="cell-line-height">
                      <p class="font-medium-1 line-height-1 mb-0 cursor-pointer"
                        (click)="openModalRes(responsibilityModal,row?.responsibilities)">{{ row?.user?.name }}</p>
                      <div class="d-flex flex-wrap type-box mt-1">
                        <div class="text-muted font-small-2" *ngFor="let type of row?.employeetype; last as isLast">
                          <span>
                            <span *ngIf="type?.displayname == 'Managment'"
                              [ngClass]="{ 'bg-light-success badge badge-pill ':type?.displayname == 'Managment'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'Engineering'"
                              [ngClass]="{ 'bg-light-warning badge badge-pill ':type?.displayname == 'Engineering'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'Sales'"
                              [ngClass]="{ 'bg-light-danger badge badge-pill':type?.displayname == 'Sales'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'Operation'"
                              [ngClass]="{'bg-light-info badge badge-pill':type?.displayname == 'Operation'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'Finance'"
                              [ngClass]="{'bg-light-primary badge badge-pill':type?.displayname == 'Finance'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'HR'"
                              [ngClass]="{'bg-light-danger badge badge-pill':type?.displayname == 'HR'}">{{type?.displayname}}</span>
                            <span *ngIf="type?.displayname == 'Training Moderator'"
                              [ngClass]="{'bg-light-danger badge badge-pill':type?.displayname == 'Training Moderator'}">{{type?.displayname}}</span>

                          </span>
                          <!-- <span *ngIf=" row?.employeetype.length>1 && !isLast">,</span> -->
                        </div>
                      </div>
                      <div class="d-flex flex-wrap skills-box mt-1">
                        <div class="text-muted font-small-2" *ngFor="let skill of row?.skills; last as isLast">
                          <span class="bg-light-primary badge badge-pill"> {{skill?.displayname}}</span>
                          <!-- <span *ngIf=" row?.skills.length>1 && !isLast">,</span> -->
                        </div>
                      </div>
                      <div class="d-flex flex-wrap skills-box mt-1">
                        <div class="text-muted font-small-2" *ngFor="let user of row?.report_to; last as isLast">
                          <span class="bg-light-info badge badge-pill"
                            (click)="openModalReportTo(reportToModal,row?.report_to,row?._id)"> {{user?.name}}</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Badge" prop="emp_badge" [width]="40">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p *ngFor="let badge of row?.emp_badge">
                    <span>
                      <span class="mr-1" [ngClass]="{'bg-light-success badge badge-pill':badge.displayname == 'Free'}"
                        placement="top" *ngIf="badge.displayname == 'Free'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-success cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        [ngClass]="{'bg-light-warning badge badge-pill':badge.displayname == 'On Leave'}"
                        placement="top" *ngIf="badge.displayname == 'On Leave'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-warning cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        [ngClass]="{'bg-light-danger badge badge-pill':badge.displayname == 'On Alert'}" placement="top"
                        *ngIf="badge.displayname == 'On Alert'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-danger cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        [ngClass]="{'bg-light-info badge badge-pill':badge.displayname == 'Work From Home'}"
                        placement="top" *ngIf="badge.displayname == 'Work From Home'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-info cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        [ngClass]="{'bg-light-secondary badge badge-pill':badge.displayname == 'Half-Day'}"
                        placement="top" *ngIf="badge.displayname == 'Half-Day'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-secondary cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        [ngClass]="{'bg-light-grey badge badge-pill':badge.displayname == 'Short-Leave'}"
                        placement="top" *ngIf="badge.displayname == 'Short-Leave'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-grey cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                      <span class="mr-1"
                        ngClass="bg-light-primary badge badge-pill"
                        placement="top" *ngIf="badge.displayname !== 'Free' && badge.displayname !== 'On Leave' && badge.displayname !== 'On Alert' && badge.displayname !== 'Work From Home'&& badge.displayname !== 'Half-Day' && badge.displayname !== 'Short-Leave'">
                        <span class="cursor-pointer" (click)="openModal(myModal,row?._id,row?.emp_badge)">
                          {{badge.displayname}}</span>
                        <span class="crossBtn"><i class="ft-x text-primary cursor-pointer ml-2"
                            (click)="updateBadge('delete',row.user?._id,row?.emp_badge,badge._id)"></i></span>
                      </span>
                    </span>
                  </p>
                  <span>
                    <i class="ft-plus text-primary cursor-pointer ml-1" placement="right" ngbTooltip="add badge"
                      (click)="openModal(myModal,row?._id,'')"></i>
                  </span>
                  <!-- <p >
                      <span *ngIf="row?.emp_badge[0]?.displayname == 'Free'"
                        [ngClass]="{'bg-light-success badge badge-pill':row?.emp_badge[0]?.displayname == 'Free'}">
                       <span class="cursor-pointer" [matMenuTriggerFor]="emp_status"> {{row?.emp_badge[0]?.displayname}}</span>   <span class="crossBtn"><i class="ft-x text-success cursor-pointer ml-2" (click)="updateBadge('delete',row.user?._id)"></i></span>
                      </span>
                      <span *ngIf="row?.emp_badge[1]?.displayname == 'On Leave'"
                        [ngClass]="{'bg-light-warning badge badge-pill':row?.emp_badge[0]?.displayname == 'On Leave'}">
                       <span class="cursor-pointer" [matMenuTriggerFor]="emp_status"> {{row?.emp_badge[0]?.displayname}}</span>  <span class="crossBtn"><i class="ft-x text-warning cursor-pointer ml-2" (click)="updateBadge('delete',row.user?._id)"></i></span>
                      </span>
                      <span *ngIf="row?.emp_badge[2]?.displayname == 'On Alert'"
                        [ngClass]="{'bg-light-danger badge badge-pill':row?.emp_badge[0]?.displayname == 'On Alert'}">
                       <span class="cursor-pointer" [matMenuTriggerFor]="emp_status"> {{row?.emp_badge[0]?.displayname}}</span>   <span class="crossBtn"><i class="ft-x text-danger cursor-pointer ml-2" (click)="updateBadge('delete',row.user?._id)"></i></span>
                      </span>
                    </p> -->
                  <mat-menu #emp_status="matMenu">

                    <div>
                      <div *ngFor="let badge of emp_badgeList">
                        <button mat-menu-item *ngIf="badge?.name !== row?.emp_badge[0]?.name"
                          (click)="updateEmpBadge(row.user?._id,badge._id)">
                          <span>
                            <span [ngClass]="{'bg-light-success badge badge-pill':badge.displayname == 'Free'}"
                              placement="top" *ngIf="badge.displayname == 'Free'">{{badge.displayname}}</span>
                            <span [ngClass]="{'bg-light-warning badge badge-pill':badge.displayname == 'On Leave'}"
                              placement="top" *ngIf="badge.displayname == 'On Leave'">{{badge.displayname}}</span>
                            <span [ngClass]="{'bg-light-danger badge badge-pill':badge.displayname == 'On Alert'}"
                              placement="top" *ngIf="badge.displayname == 'On Alert'">{{badge.displayname}}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Contract" prop="jobs" [width]="50">
                <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngFor="let job of row?.jobs">
                    <!-- <a [routerLink]="['/jobs/edit',row?.jobs[0]?._id]" target="_blank">
                      <span *ngIf="job?.workon[0]?.displayname ==='Product'"
                      class="jobs-chips job-chips-product-color badge badge-pill"> {{job?.name}} </span>
                    </a>
                    <a [routerLink]="['/jobs/edit',row?.jobs[0]?._id]" target="_blank">
                      <span *ngIf="job?.workon[0]?.displayname ==='Project'"
                      class="jobs-chips job-chips-project-color badge badge-pill"> {{job?.name}} </span>
                    </a> -->

                    <span *ngIf="job?.workon[0]?.displayname ==='Product'"
                      class="jobs-chips job-chips-product-color badge badge-pill" (click)="openModalUser(myModal2,job,job._id)"> {{job?.name}} </span>
                      <span *ngIf="job?.workon[0]?.displayname ==='Project'"
                      class="jobs-chips job-chips-project-color badge badge-pill" (click)="openModalUser(myModal2,job,job._id)"> {{job?.name}} </span>
                    
                   
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Current Task" prop="current_task" [width]="150">
                <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div>
                    <div title="Double click to edit task-box" (dblclick)="editing[rowIndex + '-current_task'] = true"
                    *ngIf="!editing[rowIndex + '-current_task']">
                    <div>
                      <span class="current-task-box" *ngIf="row?.current_task" [innerText]="row?.current_task"></span>
                      <span *ngIf="!row?.current_task || row?.current_task =='\n'">
                        <i class="ft-plus text-primary cursor-pointer" placement="right"
                          ngbTooltip="add current task"></i>
                      </span>
                    </div>

                    <span *ngIf="row?.current_task && row?.task_status == 'completed' "
                      [ngClass]="{'bg-light-success badge badge-pill':row?.task_status == 'completed'}">
                      {{row?.task_status}} </span>
                    <span *ngIf="row?.current_task && row?.task_status == 'pending' "
                      [ngClass]="{'bg-light-danger badge badge-pill':row?.task_status == 'pending'}">
                      {{row?.task_status}} </span>
                  </div>
                  <p>
                    <b>{{row?.updated_at | date:'medium'}}</b>
                  </p>
                  </div>
                  

                  <textarea autofocus class="form-control form-control-sm"
                    (blur)="inlineEditingUpdate($event, 'current_task', rowIndex,row?._id)"
                    *ngIf="editing[rowIndex + '-current_task']" type="text" cols="30" rows="1"
                    [(ngModel)]="row.current_task"></textarea>

                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Next Task" prop="next_task" [width]="150">
                <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div title="Double click to edit" (dblclick)="editing[rowIndex + '-next_task'] = true"
                    *ngIf="!editing[rowIndex + '-next_task']">
                    <span class="next-task-box" *ngIf="row?.next_task" [innerText]="row?.next_task"></span>
                    <span *ngIf="!row?.next_task || row?.next_task == '\n'">
                      <i class="ft-plus text-primary cursor-pointer" placement="right" ngbTooltip="add next task"></i>
                    </span>

                  </div>
                  <textarea autofocus class="form-control form-control-sm"
                    (blur)="inlineEditingUpdate($event, 'next_task', rowIndex,row?._id)"
                    *ngIf="editing[rowIndex + '-next_task']" type="text" cols="30" rows="1"
                    [(ngModel)]="row.next_task"></textarea>

                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Actions" [width]="40"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <!-- <i class="ft-plus text-primary cursor-pointer" placement="right"
                    ngbTooltip="add badge" (click)="openModal(myModal,row?._id)"></i> -->
                    <i class="ft-edit text-primary cursor-pointer mr-2"
                      [routerLink]="['/employees/edit',row?._id]"></i>
                    <!-- <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                      (click)="Delete(row._id)"></i>
                    <i class="ft-copy text-primary cursor-pointer ml-2 mr-2" placement="top"
                      ngbTooltip="Copy Default Password" (click)="copyToClipboard(row?.user?.name,row?.user?.phone)"></i>
                    <i *ngIf="user_role.roles =='admin'" class="icon-key text-primary cursor-pointer" placement="top"
                      ngbTooltip="set default password" (click)="setDefaultPassword(row?.user?._id, row?.user?.name)"></i> -->
              </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!--------- -->

<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!isBadgeUpdate">Add New Badge</h4>
      <h4 class="modal-title" *ngIf="isBadgeUpdate">Badge Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-select [items]="emp_badgeList" bindLabel="displayname" bindValue="_id" placeholder="Select Type"
        [(ngModel)]="selected_emp_badge" [multiple]="true" [ngModelOptions]="{ standalone: true }"
        (change)="getBadgeId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
      </ng-select>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateBadge('add','','','')">Submit</button>
    </div>
  </ng-template>
</div>
<!--------- Update Report To popup -------------->
<div>
  <ng-template #reportToModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Report To</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-select [items]="rows" bindLabel="name" bindValue="_id" placeholder="Select User" [(ngModel)]="selected_user"
        [multiple]="true" [ngModelOptions]="{ standalone: true }" (change)="getSelectUserId($event)" [appendTo]="'body'"
        [virtualScroll]="true" [clearSearchOnAdd]="true">
      </ng-select>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateReportTo()">Submit</button>
    </div>
  </ng-template>
</div>

<!--------  Show Responsibility Popup ----------------- -->
<div>
  <ng-template #responsibilityModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Responsibility</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p [innerText]="responsibilities_data">
      </p>

    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateReportTo()">Submit</button>
    </div> -->
  </ng-template>
</div>

<!-- -------- -->

<div>
  <ng-template #myModal2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Hunting By</label>
        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Hunting"
          [(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }" [multiple]="true"
          (change)="getHuntId($event)" #huntingBy="ngModel">
        </ng-select>
      </div>
      <div class="form-group">
        <label>Farming By</label>
        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Farming"
          [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }" [multiple]="true"
          (change)="getFarmId($event)" #farmingBy="ngModel">
        </ng-select>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="updateJob()">Submit</button>
    </div>
  </ng-template>
</div>

